import { useMemo } from 'react'
import { convertDate } from '../../../helpers/dates-formatter'
import banerAsia from '../../../assets/images/event-asia-baner.png'

export const useTournamentData = tournament => {
  const bannerBackground = useMemo(
    () => `url(${tournament?.media?.pageHeaderBanner || banerAsia})`,
    [tournament?.media?.pageHeaderBanner]
  )

  const tournamentLogo = useMemo(
    () => tournament?.media?.logo || banerAsia,
    [tournament?.media?.logo]
  )

  const tournamentName = useMemo(
    () => tournament?.name || false,
    [tournament?.name]
  )

  const tournamentLayer = useMemo(
    () => tournament?.layer || false,
    [tournament?.layer]
  )

  const tournamentDateRange = useMemo(() => {
    if (!tournament?.startedAt || !tournament?.endedAt) return false
    return `${convertDate(tournament?.startedAt)} - ${convertDate(tournament?.endedAt)}`
  }, [tournament?.startedAt, tournament?.endedAt])

  const tournamentInfo = useMemo(() => {
    const parts = []
    if (tournament?.tournamentType) parts.push(tournament?.tournamentType)
    if (tournament?.location) parts.push(tournament?.location)
    return parts.join(' | ')
  }, [tournament?.tournamentType, tournament?.location])

  const tournamentStatus = useMemo(
    () => tournament?.status || 'Not actual',
    [tournament?.status]
  )

  return {
    bannerBackground,
    tournamentLogo,
    tournamentName,
    tournamentLayer,
    tournamentDateRange,
    tournamentInfo,
    tournamentStatus,
  }
}
